import React from 'react';
import './Spinner.css';

const Spinner = ({ fullPage = false, message = "Loading..." }) => {
    if (fullPage) {
        return (
            <div className="spinner-container full-page">
                <div className="spinner"></div>
                {message && <p className="spinner-text">{message}</p>}
            </div>
        );
    }

    return (
        <div className="spinner-container">
            <div className="spinner"></div>
            {message && <p className="spinner-text">{message}</p>}
        </div>
    );
};

export default Spinner;
